import React from 'react';

// Types
import { Type, SubType } from 'Shared/types/Capture.types';

// Images
import OnedriveLogo from 'Shared/images/OneDriveLogo.svg';
import MsWordLogo from 'Shared/images/AttachmentTypesIcons/msword.svg';
import MsExcelLogo from 'Shared/images/AttachmentTypesIcons/msexcel.svg';
import MsPptLogo from 'Shared/images/AttachmentTypesIcons/msppt.svg';
import GoogleSpreadsheetLogo from 'Shared/images/AttachmentTypesIcons/googlespreadsheet.svg';
import GooglePresentationLogo from 'Shared/images/AttachmentTypesIcons/googlepresentation.svg';
import GoogleDocsLogo from 'Shared/images/AttachmentTypesIcons/googledocs.svg';
import SalesforceLogo from 'Shared/images/salesforce-logo.svg';
import HubspotLogo from 'Shared/images/hubspot-sprocket-logo.svg';
import FigmaLogo from 'Shared/images/figma-logo.svg';
import GithubLogo from 'Shared/images/GithubLogo.svg';
import JiraLogo from 'Shared/images/JiraLogo.svg';
import AsanaLogo from 'Shared/images/AsanaLogo.svg';

// Styles
import './SurfaceItemLogo.scss';

type Props = {
  surfaceItem;
};

const SurfaceItemLogo = ({ surfaceItem }: Props) => {
  const getLogo = () => {
    const { type, subtype } = surfaceItem;
    if (type === Type.ONEDRIVE && subtype == SubType.WORD_DOCUMENT) return MsWordLogo;
    if (type === Type.ONEDRIVE && subtype == SubType.POWERPOINT_PRESENTATION) return MsPptLogo;
    if (type === Type.ONEDRIVE && subtype == SubType.EXCEL_SPREADSHEET) return MsExcelLogo;
    if (type === Type.ONEDRIVE) return OnedriveLogo;

    if (type === Type.GOOGLE_DRIVE && subtype == SubType.DOCUMENT) return GoogleDocsLogo;
    if (type === Type.GOOGLE_DRIVE && subtype == SubType.SPREADSHEET) return GoogleSpreadsheetLogo;
    if (type === Type.GOOGLE_DRIVE && subtype == SubType.PRESENTATION) return GooglePresentationLogo;
    if (type === Type.SALESFORCE) return SalesforceLogo;
    if (type === Type.HUBSPOT) return HubspotLogo;
    if (type === Type.FIGMA) return FigmaLogo;
    if (type === Type.GITHUB) return GithubLogo;
    if (type === Type.JIRA) return JiraLogo;
    if (type === Type.ASANA) return AsanaLogo;
  };

  const logo = getLogo();

  const baseClassName = 'SurfaceItemLogo';

  return (
    <a href={surfaceItem.external_link} target="_blank" rel="noreferrer" className={baseClassName}>
      <img className={`${baseClassName}__img`} src={logo} alt={logo} />
    </a>
  );
};

export default SurfaceItemLogo;
